import {
  TagPickerList as FluentTagPickerList,
  TagPickerListProps as FluentTagPickerListProps,
  tokens,
  useTagPickerContext_unstable,
} from '@fluentui/react-components';
import React, { useMemo } from 'react';

export type TagPickerListProps = FluentTagPickerListProps;

const appearanceBackgroundMap: Record<string, string> = {
  'filled-darker': tokens.colorNeutralBackground3,
  'filled-lighter': tokens.colorNeutralBackground1,
};

/**
 * Themed TagPickerList wrapper that applies the correct background color
 * based on the TagPicker's appearance prop.
 *
 * Fluent UI's TagPickerList always uses colorNeutralBackground1 regardless
 * of the parent TagPicker's appearance. This wrapper reads the appearance
 * from TagPicker context and applies the matching background color.
 */
export const TagPickerList: React.FC<TagPickerListProps> = ({ style, ...props }) => {
  const appearance = useTagPickerContext_unstable((ctx) => ctx.appearance);

  const mergedStyle = useMemo(
    () => ({
      backgroundColor: appearanceBackgroundMap[appearance],
      ...style,
    }),
    [appearance, style],
  );

  return <FluentTagPickerList style={mergedStyle} {...props} />;
};

TagPickerList.displayName = 'TagPickerList';
